import { Reducer } from 'redux'
import { setItem } from '@labrav/common'

import {
  ProductListingFilterType,
  type ProductListingFilterAction,
  type ProductListingFilters,
  initialState,
} from './types'

export * from './types'

export const reducer: Reducer<
  ProductListingFilters,
  ProductListingFilterAction
> = (state = initialState, action) => {
  switch (action.type) {
    case ProductListingFilterType.SET_CLOUD_MARKETPLACE: {
      setItem('cloudType', action.payload)
      return {
        ...state,
        cloudMarketplace: action.payload,
      }
    }
    case ProductListingFilterType.SET_CREATE_PRIVATE_OFFER_MODAL_OPEN: {
      return {
        ...state,
        createPrivateOfferModalOpen: action.payload,
      }
    }
    default: {
      return state
    }
  }
}
